import { Button } from '@creditornot/cb-button';
import { cbSemanticCssVars, typographyCss } from '@creditornot/cb-ingredients';
import { Select } from '@creditornot/cb-select';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { IntegrationAccessTypes } from './types';

type ApiAccessIntroProps = {
  onOpenMenuApiModal: (open: boolean) => void;
  onOpenOrderApiModal: (open: boolean) => void;
};

const ApiContentIntroContainer = styled.div`
  min-height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 64px 16px;
`;

const ApiContentIntroContent = styled.div`
  color: ${cbSemanticCssVars.textSecondary};
  ${typographyCss.Body2()}
  font-weight: bold;
`;

const ApiContentIntroDetails = styled.div`
  color: ${cbSemanticCssVars.textSecondary};
  margin-block-end: 30px;
  ${typographyCss.Body3()}
`;

const StyledSelect = styled(Select)`
  min-width: 200px;
  margin-block-end: 16px;
`;

const ApiAccessIntroduction = ({ onOpenMenuApiModal, onOpenOrderApiModal }: ApiAccessIntroProps) => {
  const intl = useIntl();
  const [selectedApi, setSelectedApi] = useState<IntegrationAccessTypes>(IntegrationAccessTypes.ORDER_API);

  const onOpenModal = (shouldOpen: boolean) => {
    if (selectedApi === IntegrationAccessTypes.ORDER_API) {
      onOpenOrderApiModal(shouldOpen);
    } else if (selectedApi === IntegrationAccessTypes.MENU_API) {
      onOpenMenuApiModal(shouldOpen);
    }
  };

  return (
    <ApiContentIntroContainer>
      <ApiContentIntroContent>
        <FormattedMessage id="merchant-integrations.api-content.introduction" />
      </ApiContentIntroContent>
      <ApiContentIntroDetails>
        <FormattedMessage id="merchant-integrations.api-content.introduction-details" />
      </ApiContentIntroDetails>

      <StyledSelect
        value={selectedApi}
        onChange={(value: IntegrationAccessTypes) => {
          setSelectedApi(value);
        }}
        options={[
          {
            label: intl.formatMessage({ id: 'merchant-integrations.order-api.title' }),
            value: IntegrationAccessTypes.ORDER_API,
          },
          {
            label: intl.formatMessage({ id: 'merchant-integrations.menu-api.title' }),
            value: IntegrationAccessTypes.MENU_API,
          },
        ]}
      />
      <Button size="small" variant="primary" onClick={() => onOpenModal(true)}>
        <FormattedMessage id="merchant-integrations.menu-api-intro-action" />
      </Button>
    </ApiContentIntroContainer>
  );
};

export default ApiAccessIntroduction;
